import { padding } from "ds_legacy/materials/metrics";
import { MenuItem } from "dsl/atoms/MenuItem";
import { OptionProps } from "react-select";
import { SelectOption } from "./types";

export function Option({
  children,
  innerProps,
  isFocused,
  isSelected,
  selectProps: { classes },
}: OptionProps<SelectOption>) {
  return (
    <MenuItem
      className={classes.menuItem}
      component="div"
      selected={isFocused}
      sx={{
        fontWeight: isSelected ? 500 : 400,
        padding: padding(1, 2),
      }}
      {...(innerProps as any)}
      role="option"
    >
      <>{children}</>
    </MenuItem>
  );
}
